import React from 'react';
import { Helmet } from 'react-helmet';
import MainLayout from '../components/Layout/MainLayout';
import ComponentsSection from '../components/Sections/Components';
import ContributingSection from '../components/Sections/Contributing';
import FoundationsSection from '../components/Sections/Foundations';
import HeroSection from '../components/Sections/Hero';
import NavMenu from '../components/Sections/NavMenu';
import PrinciplesSection from '../components/Sections/Principles';
// import QuickLinksSection from '../components/Sections/QuickLinks';

const pageTitle = 'Emoji Design System';

const Home: React.FC = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Design System" />
        <meta property="og:title" content={pageTitle} />
      </Helmet>

      <NavMenu />
      <HeroSection />
      <PrinciplesSection />
      <FoundationsSection />
      <ComponentsSection />
      <ContributingSection />
    </MainLayout>
  );
};

export default Home;
